import { useIntl } from "react-intl";

export const useIntlMessage = () => {
    const intl = useIntl();
    return (id, defaultMessage) => {
        return intl.formatMessage({ id, defaultMessage });
    };
};